import React from 'react';
import BonusesCard from './BonusesCard';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import I18n from 'app/i18n';
import emptyBonusCoin from 'images/bonuses/bonuses-card/empty-bonus-coin.png';
import {modalConfirm} from 'app/utils/modals/popups';
import {ADVANCE_TYPES} from 'app/utils/balance/betsBalance';
import BonusInterfaces from 'app/interfaces/BonusInterface';

interface ActiveBonusesCardInterface {
    bonus_balance: string
    cancelBonus: (id: number) => void
    hideExpiredBonus: (id: number) => void
    activeBonus?: BonusInterfaces
}

const ActiveBonusesCard: React.FC<ActiveBonusesCardInterface> = props => {
    const {activeBonus} = props;

    const handleClick = (): void => {
        const {cancelBonus, bonus_balance} = props;
        const {active, id, type} = activeBonus;

        modalConfirm(`${I18n.t('cancel_bonus_message')}${ADVANCE_TYPES.includes(type) && active
            ? I18n.t('cancel_advance_message', {amount: bonus_balance})
            : ''}`, () => {
            cancelBonus(id);
        });
    };

    return <div className="active-bonuses-card">
        {activeBonus
            ? <div className="active-bonuses-card__wrapper active-bonuses-card__wrapper-active">
                <BonusesCard
                    hideExpiredBonus={props.hideExpiredBonus}
                    {...activeBonus}
                />
                <div className="bonuses-card__close" onClick={handleClick}>
                    <SpriteIcon name="#svg-close" size={{height: 12, width: 12}}/>
                </div>
            </div>
            : <div className="active-bonuses-card__wrapper active-bonuses-card__wrapper-empty">
                <img src={emptyBonusCoin} alt="EGB coin" className="active-bonuses-card__img"/>
                <p className="active-bonuses-card__text">{I18n.t('bonuses_page.activate_available_bonus_to_start')}</p>
            </div>}
    </div>;
};

export default ActiveBonusesCard;
